/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

export const maxProfileEntryLength = 500 as const

export type MaxProfileEntryLength = typeof maxProfileEntryLength
